import React from 'react';
import { __ } from '../i18n';
import styled from 'styled-components';

const Container = styled.div``;

const AgreementText = styled.span`
  color: #999999;
`;

const Link = styled.a`
  color: #0069ff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const TermsAndPrivacy = ({ type = 'access' }) => (
  <Container>
    <AgreementText>
      {type === 'access'
        ? __('By accessing, you agree to our')
        : __('By creating an account, you agree to our')}
    </AgreementText>
    &nbsp;
    <Link href="/terms" target="_blank">
      {__('Terms of Service').toLocaleLowerCase()}
    </Link>
    &nbsp;
    <AgreementText>{`${__('and')}`}</AgreementText>
    &nbsp;
    <Link href="/privacy" target="_blank">
      {__('Privacy Policy').toLocaleLowerCase()}
    </Link>
  </Container>
);

export default TermsAndPrivacy;
